(function () {
  'use strict';

  function injectBadges() {
    var root = document.querySelector('[data-yazli-pdp]');
    if (!root) return;
    var tpl = root.querySelector('[data-yazli-pdp-badges]');
    if (!tpl || !tpl.content || !tpl.content.childNodes.length) return;

    var title =
      document.querySelector('.productView-title') ||
      document.querySelector('.productView-product .productView-title') ||
      document.querySelector('h1.productView-title') ||
      document.querySelector('.product__title') ||
      document.querySelector('h1');

    if (!title || title.parentElement.querySelector('.yazli-pdp__badges-host')) return;

    var host = document.createElement('div');
    host.className = 'yazli-pdp__badges-host';
    host.appendChild(tpl.content.cloneNode(true));
    if (title.nextSibling) {
      title.parentElement.insertBefore(host, title.nextSibling);
    } else {
      title.parentElement.appendChild(host);
    }
  }

  function markSignatureBody() {
    var root = document.querySelector('[data-yazli-pdp]');
    if (!root) return;
    document.documentElement.classList.add('yazli-signature-pdp');
    document.body.classList.add('yazli-pdp-ready');
    var perfume = root.getAttribute('data-perfume');
    if (perfume) document.documentElement.setAttribute('data-yazli-perfume', perfume);
  }

  function placeBundlesAfterNotes() {
    var anchor =
      document.querySelector('.yazli-pdp__notes') ||
      document.querySelector('.yazli-pdp__exclusive');
    if (!anchor) return;

    var bundleSection =
      document.querySelector('#shopify-section-yazli_bundle_options') ||
      document.querySelector('.shopify-section:has(.yazli-bo)') ||
      (document.querySelector('.yazli-bo') && document.querySelector('.yazli-bo').closest('.shopify-section'));

    if (!bundleSection) return;

    var pdpRoot = anchor.closest('.yazli-pdp') || anchor.parentElement;
    if (!pdpRoot || !pdpRoot.parentElement) return;

    if (anchor.nextSibling) {
      pdpRoot.insertBefore(bundleSection, anchor.nextSibling);
    } else {
      pdpRoot.appendChild(bundleSection);
    }
  }

  function hideWeightOptions() {
    document.querySelectorAll('.product-form__input, .productView-optionsItem, fieldset').forEach(function (el) {
      var t = (el.textContent || '').replace(/\s+/g, ' ');
      if (/وزن|0\.5\s*Kg|كجم/i.test(t) && t.length < 120) {
        el.style.display = 'none';
      }
    });
  }

  function hideLegacyBuybox() {
    var selectors = [
      '.aromatic-intro',
      '.aromatic-guarantee',
      '.aromatic-product-details',
      '.aromatic-faq-section',
      '.lignum-yazli-copy',
      '#lignum-yazli-intro',
      '#lignum-yazli-guarantee',
      '#lignum-yazli-details',
      '#lignum-faq',
      '.lignum-faq-section',
      '.obscure-yazli-copy',
      '.shadow-yazli-copy',
      '.obscure-yazli-intro',
      '.shadow-yazli-intro',
      '.obscure-yazli-details',
      '.shadow-yazli-details',
      '.productView-desc',
      '.shadow-faq-section',
      '.obscure-faq-section',
      '.yazli-tfa-copy',
      '#yazli-tfa-intro',
      '#yazli-tfa-benefits'
    ];
    document.querySelectorAll(selectors.join(',')).forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function steadyButtons() {
    document
      .querySelectorAll(
        '.productView-action .button, #product-add-to-cart, .product-form__submit, .shopify-payment-button__button'
      )
      .forEach(function (btn) {
        btn.classList.remove('an-horizontal-shaking', 'an-vertical-shaking', 'an-pulse', 'animated');
        btn.style.animation = 'none';
      });
  }

  function nestFreeDeliveryNearPrice() {
    var price =
      document.querySelector('.productView-price') ||
      document.querySelector('.productView-product .price');
    var free =
      document.querySelector('.yazli-ship') ||
      document.querySelector('.yazli-free-delivery');
    if (!price || !free || price.contains(free)) return;
    if (price.parentElement) {
      price.parentElement.insertBefore(free, price.nextSibling);
    }
  }

  function initTabs() {
    document.querySelectorAll('[data-yazli-pdp-tabs]').forEach(function (root) {
      if (root.getAttribute('data-yazli-tabs-ready')) return;
      root.setAttribute('data-yazli-tabs-ready', '1');

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-yazli-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-yazli-panel]'));

      function activate(id) {
        tabs.forEach(function (tab) {
          var on = tab.getAttribute('data-yazli-tab') === id;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (panel) {
          var on = panel.getAttribute('data-yazli-panel') === id;
          panel.classList.toggle('is-active', on);
          if (on) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activate(tab.getAttribute('data-yazli-tab'));
        });
        tab.addEventListener('keydown', function (e) {
          var i = tabs.indexOf(tab);
          var next = -1;
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            var dir = e.key === 'ArrowRight' ? 1 : -1;
            if (document.documentElement.dir === 'rtl' || root.closest('[dir="rtl"]')) dir *= -1;
            next = (i + dir + tabs.length) % tabs.length;
          } else if (e.key === 'Home') {
            next = 0;
          } else if (e.key === 'End') {
            next = tabs.length - 1;
          }
          if (next < 0) return;
          e.preventDefault();
          tabs[next].focus();
          activate(tabs[next].getAttribute('data-yazli-tab'));
        });
      });

      if (root.querySelector('.yazli-pdp__thanks:not([hidden])')) {
        activate('reviews');
      }
    });
  }

  function initCustomerReviews() {
    var STORAGE_KEY = 'yazli_pdp_reviews_v1';
    var list = document.querySelector('[data-yazli-review-list]');
    var form = document.querySelector('[data-yazli-review-form], #yazli-pdp-review-form');
    if (!list || !form) return;

    var handle = list.getAttribute('data-yazli-review-handle') || '';
    var thanks = form.querySelector('[data-yazli-review-thanks]');
    var submitBtn = form.querySelector('.yazli-pdp__submit, button[type="submit"]');

    function readStore() {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') || {};
      } catch (e) {
        return {};
      }
    }

    function writeStore(data) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      } catch (e) {}
    }

    function starsHtml(rating) {
      var n = Math.max(1, Math.min(5, parseInt(rating, 10) || 5));
      var html = '<div class="yazli-pdp__stars" aria-label="' + n + ' / 5">';
      for (var i = 1; i <= 5; i++) {
        html += '<span class="yazli-pdp__star' + (i <= n ? ' is-on' : '') + '" aria-hidden="true">★</span>';
      }
      return html + '</div>';
    }

    function escapeHtml(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function appendReview(item) {
      if (!item || !item.author || !item.body) return;
      var existing = list.querySelectorAll('.yazli-pdp__review-author');
      for (var i = 0; i < existing.length; i++) {
        var textEl = existing[i].parentElement && existing[i].parentElement.querySelector('.yazli-pdp__review-text');
        if (
          existing[i].textContent === item.author &&
          textEl &&
          textEl.textContent === item.body
        ) {
          return;
        }
      }
      var li = document.createElement('li');
      li.className = 'yazli-pdp__review yazli-pdp__review--customer';
      li.innerHTML =
        starsHtml(item.rating) +
        '<p class="yazli-pdp__review-text">' +
        escapeHtml(item.body) +
        '</p>' +
        '<p class="yazli-pdp__review-author">' +
        escapeHtml(item.author) +
        '</p>';
      list.appendChild(li);
      li.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    function openReviewsTab() {
      var tabsRoot = document.querySelector('[data-yazli-pdp-tabs]');
      if (!tabsRoot) return;
      var reviewsTab = tabsRoot.querySelector('[data-yazli-tab="reviews"]');
      if (reviewsTab) reviewsTab.click();
    }

    function showThanks() {
      if (!thanks) return;
      thanks.hidden = false;
      thanks.removeAttribute('hidden');
    }

    function loadSaved() {
      var store = readStore();
      var items = store[handle] || [];
      items.forEach(appendReview);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var nameInput = form.querySelector('[data-yazli-review-name]');
      var emailInput = form.querySelector('[data-yazli-review-email]');
      var bodyInput = form.querySelector('[data-yazli-review-body]');
      var ratingInput = form.querySelector('input[name="rating"]:checked');

      if (nameInput && !nameInput.value.trim()) {
        nameInput.reportValidity();
        return;
      }
      if (emailInput && !emailInput.checkValidity()) {
        emailInput.reportValidity();
        return;
      }
      if (bodyInput && !bodyInput.value.trim()) {
        bodyInput.reportValidity();
        return;
      }

      var review = {
        author: nameInput ? nameInput.value.trim() : '',
        body: bodyInput ? bodyInput.value.trim() : '',
        rating: ratingInput ? ratingInput.value : '5',
        createdAt: Date.now()
      };
      if (!review.author || !review.body) return;

      var store = readStore();
      if (!store[handle]) store[handle] = [];
      store[handle].push(review);
      writeStore(store);

      appendReview(review);
      openReviewsTab();
      showThanks();

      if (submitBtn) submitBtn.disabled = true;
      form.reset();
      var five = form.querySelector('input[name="rating"][value="5"]');
      if (five) five.checked = true;
      if (submitBtn) {
        setTimeout(function () {
          submitBtn.disabled = false;
        }, 800);
      }
    });

    loadSaved();
  }

  function boot() {
    markSignatureBody();
    injectBadges();
    hideWeightOptions();
    placeBundlesAfterNotes();
    hideLegacyBuybox();
    steadyButtons();
    nestFreeDeliveryNearPrice();
    initTabs();
    initCustomerReviews();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
